import type { ICustomControlProcedureAddEditProps } from '../interfaces/customControlProcedureAddEditProps';
import { ServiceCode } from '../../../../../common/enums/serviceCode';
import { translateKey } from '../../../../translate';
import { useCheckHasOrthOInLastSixMonths } from '../../../../utils/hooks/useCheckHasOrthOInLastSixMonths';
import { useEpisodeContext } from '../../../../utils/hooks/useEpisodeContext';
import { NewOrEditProcedureProcessContainer } from '../utils/v1/NewOrEditProcedureProcessContainer';
import { OrthOAlert } from './OrthOAlert';
import { OrthopticsV1ProcedureAddEdit } from './OrthopticsV1ProcedureAddEdit';

export function OrthOV1ProcedureAddEdit(props: ICustomControlProcedureAddEditProps): JSX.Element {
    const { patient } = useEpisodeContext();
    const hasOrthOInLastSixMonths = useCheckHasOrthOInLastSixMonths(patient.id);

    return (
        <NewOrEditProcedureProcessContainer
            currentProcedure={props.currentProcedure}
            isBioGrader={true}
            isFirstItem={props.isFirstItem}
            itemState={props.itemState}
            process={props.process}
            service={props.service}
        >
            {hasOrthOInLastSixMonths === true && !props.request.id && (
                <OrthOAlert
                    buttonText={translateKey('orthOProcedure.convert_to_subsequent_ortho')}
                    serviceCodeForButton={ServiceCode.OrthOFol}
                    text={translateKey('orthOProcedure.previous_ortho')}
                />
            )}

            {(hasOrthOInLastSixMonths === false || props.request.id) && <OrthopticsV1ProcedureAddEdit {...props} />}
        </NewOrEditProcedureProcessContainer>
    );
}
